import React            from 'react';

const DirectOffer = (
  { directOffer, translate, createDirectOfferStat, applicationCompanyId } :
  { directOffer: Object, translate: any, createDirectOfferStat: Function, applicationCompanyId: number }) => {


  function trackAndRedirect() {
    window.open(directOffer.buy_link, '_blank');
    createDirectOfferStat(applicationCompanyId, directOffer.webservice_id, 'link_click', directOffer.webservice_name);
  }

  return (
    <div className="direct-offer">
      <h3>{translate('applications.buy_insurance')}</h3>
      {parseInt(directOffer.price, 10) !== 0 ? <div className="direct-offer--content">
        <li>
          <strong>{directOffer.product_name}</strong>
        </li>

        <li>
          <i className="glyphicon glyphicon-shopping-cart" />
          {translate('applications.buy_now', { price: Math.round(directOffer.price).toLocaleString('de-DE') })}
        </li>

        <li>
          <i className="glyphicon glyphicon-briefcase" />
          <span style={{marginRight: '5px'}}>{translate('applications.coverage')}:</span>
          {' '}
          <strong> {directOffer.cover.split(',').join(', ')}</strong>
        </li>
        <div onClick={trackAndRedirect} className="btn btn-success btn-sm">
          <i className="glyphicon glyphicon-circle-arrow-right" />
          {translate('applications.buy_link')}
        </div>
        <br/>
        <em className="hidden-xs hidden-sm u-t-14"><b>* </b>{translate('applications.disclaimer')}</em>
      </div>
      :
      <div className="direct-offer--content">
        <span>{translate('applications.we_looking')}</span>
      </div>
      }
    </div>
  )
}

export default DirectOffer



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/directOffer.js